module.exports = __webpack_public_path__ + "static/wag-logo-8bcda1aa981dec658c4f05a82a59d4dd.svg";